import { useMemo } from 'react';

export const useFormatter = (language: string) =>
  useMemo(
    () =>
      new Intl.NumberFormat(language === 'es' ? 'de' : language, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    [language]
  );

export const useDecimalFormatter = (language: string) =>
  useMemo(
    () =>
      new Intl.NumberFormat(language === 'es' ? 'de' : language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    [language]
  );
